import { connect } from 'react-redux'
import { compose, branch } from 'recompose'
import {
  selectRentalPropertyBudget,
  selectRentalPropertyDownPayment,
  selectRentalPropertyMonthlyPayment
} from 'src/store/selectors/home/equity'
import { selectRentalPropertyMortgageRate } from 'src/store/selectors/mortgageRate'
import NotEnoughEquity from './NotEnoughEquity'
import { rentalProperty } from 'src/constants/equity'
import { selectShowBuyersLink } from 'src/store/selectors/layout'

const RentalPropertyContainer = compose(
  connect(state => ({
    budget: selectRentalPropertyBudget(state),
    downPaymentAmount: selectRentalPropertyDownPayment(state),
    monthlyPayment: selectRentalPropertyMonthlyPayment(state),
    mortgageRate: selectRentalPropertyMortgageRate(state),
    showBuyersLink: selectShowBuyersLink(state)
  })),
  branch(
    ({ downPaymentAmount }) => downPaymentAmount < rentalProperty.minimumEquity,
    () => NotEnoughEquity
  )
)

export default RentalPropertyContainer
